import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Folder, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  downloadedFolder: Identifiable<Folder>;
  downloadFolderContent(
    request: Boundaries["downloadFolderContent"]["request"],
  ): void;
}

function useDownloadFolderContent(folder: Identifiable<Folder>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDownloadFolderContentRequestPending(folder),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDownloadFolderContentRequestSuccess(folder),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDownloadFolderContentRequestFailure(folder),
    ),
    downloadedFolder: useSelector(() =>
      selector.getDownloadedFolderContent(folder),
    ),
    downloadFolderContent: core.downloadFolderContent,
  };
}

export { useDownloadFolderContent };
